// extracted by mini-css-extract-plugin
module.exports = {"dotGroup":"CustomSlideDot_dotGroup__3rKOY"};